import './ProfileIdentity.css';
import { useAppUi } from '../../app-ui/AppUiScope';
import baseline, { appTextStyle } from '../../app-ui/baseline';
import React from 'react';
import RecoverableImage from '../../features/images/RecoverableImage';
import { useColorScheme } from '../../contexts/ColorSchemeContext';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { profileMarkData as data } from './profileMarkData';
export function ProfileMark({ mark }) {
  const { resolvedMode } = useColorScheme();
  const { locale } = useWebLocale();
  const dark = resolvedMode === 'dark';
  if (mark?.type === 'SPONSORSHIP' && mark.sponsorshipLevel > 0) {
    const level = mark.sponsorshipLevel;
    const [background, color] =
      level >= 5
        ? ['#0D0C0B', '#E8BE58']
        : level === 4
          ? ['#CCA64C', '#18130B']
          : level === 3
            ? ['#B86F44', '#17120F']
            : level === 2
              ? ['#11100F', '#F16438']
              : ['#F16438', '#FFFFFF'];
    return (
      <span
        className="pp-profile-mark pp-supporter-mark"
        role="img"
        aria-label={locale === 'en' ? `Supporter level ${level}` : `후원 마크 ${level}단계`}
        style={{ background, color, borderBottom: level >= 5 ? '2px solid #D6A83F' : undefined }}
      >
        <svg viewBox="0 0 485 690" height="11" aria-hidden="true">
          <path d={data.path} fill="currentColor" fillRule="evenodd" />
        </svg>
      </span>
    );
  }
  const badge = mark?.type === 'ACTIVITY' && mark.activityBadge;
  if (!badge) return null;
  const tier = badge.tier || data.tiers[badge.key] || 1;
  const color =
    tier === 3
      ? dark
        ? '#B79AF5'
        : '#8064C9'
      : tier === 2
        ? dark
          ? '#7FB0E4'
          : '#3976B9'
        : dark
          ? '#FF8A63'
          : '#F16438';
  const background = !dark
    ? '#F0EEEB'
    : tier === 3
      ? '#2F2940'
      : tier === 2
        ? '#1F3044'
        : '#3A241D';
  const icon =
    data.maps.key[badge.key] ||
    data.maps.iconKey[badge.iconKey] ||
    data.maps.category[badge.category] ||
    'Award';
  return (
    <span
      className="pp-profile-mark"
      style={{ color, background }}
      role="img"
      aria-label={data.names[badge.key]?.[locale] || badge.name}
    >
      <svg
        data-profile-icon={icon}
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {(data.icons[icon] || []).map(([tag, props], index) =>
          React.createElement(tag, { ...props, key: index }),
        )}
      </svg>
    </span>
  );
}
export default function ProfileIdentity({ name, image, mark, avatar = true }) {
  const appUi = useAppUi();
  const { resolvedMode } = useColorScheme();
  const dark = resolvedMode === 'dark';
  const palette = mark?.nicknameColor;
  const color =
    palette?.key === 'VINYL' ? (dark ? '#FF79AD' : '#B8326A') : palette?.[dark ? 'dark' : 'light'];
  return (
    <span
      className="pp-profile-identity"
      style={appUi ? appTextStyle(baseline.contentText.author) : undefined}
    >
      {avatar && (
        <span className="pp-profile-avatar" aria-hidden="true">
          {image ? <RecoverableImage src={image} alt="" loading="lazy" /> : name?.slice(0, 1)}
        </span>
      )}
      <span style={{ color: /^#[\da-f]{3,8}$/i.test(color || '') ? color : undefined }}>
        {name}
      </span>
      <ProfileMark mark={mark} />
    </span>
  );
}
